module.exports = __webpack_public_path__ + "static/img/id.e4cb5897.png";